import React from "react";
import { styled, css } from "styled-components";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
const StyledWrapper = styled.div(
  ({ $align }) => css`
    display: flex;
    cursor: pointer;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: ${$align === "right" ? "flex-end" : "flex-start"};
  `
);
const ExpandedSectionToggleWrapper = ({ id, section, align = void 0, children = void 0 }) => {
  const { toggleSection } = useExpandedSections();
  const _toggleSection = () => toggleSection(id, section);
  return /* @__PURE__ */ React.createElement(StyledWrapper, { title: "Show details", onClick: _toggleSection, $align: align }, children);
};
export default ExpandedSectionToggleWrapper;
